/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_TitleInputs */

const en_landing_guide_title = /** @type {(inputs: Landing_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you need to know about Ideogram 4.5`)
};

const zh_landing_guide_title = /** @type {(inputs: Landing_Guide_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于 Ideogram 4.5，你需要知道的一切`)
};

/**
* | output |
* | --- |
* | "Everything you need to know about Ideogram 4.5" |
*
* @param {Landing_Guide_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_title = /** @type {((inputs?: Landing_Guide_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_title(inputs)
	return zh_landing_guide_title(inputs)
});
export { landing_guide_title as "landing.guide.title" }